import {createColumnHelper} from "@tanstack/react-table";
import React, {useEffect, useState} from "react";
import Table from "../../components/UI/Table";
import Card from "../../components/UI/Card";
import {getIncompleteCheckout} from "../../api/incompleteCheckout";
import {IncompleteTableActions} from "../../views/incomplete-checkout/IncompleteTableActions";
import {useNavigate} from "react-router";
import {checkPermission} from "../../util/auth";

const IncompleteIndex = () => {
    const columnHelper = createColumnHelper();
    const navigate = useNavigate();
    useEffect(() => {
        if(!checkPermission(['INCOMPLETE_CHECKOUT_VIEW'])){
            navigate("/no-access");
        }
    }, [navigate]);

    const columns = [
        columnHelper.accessor('updated_at', {
            id: "updated_at",
            header: "Last update"
        }),
        columnHelper.accessor('customer_name', {
            id: "customer_name",
            header: "Customer Name"
        }),
        columnHelper.accessor('quantity', {
            id: "quantity",
            header: "Quantity"
        }),

        columnHelper.display({
            id: "total",
            header: "Total",
            classes: 'text_right',
            cell: props => <span>${props.row.original.total}</span>,
        }),

        columnHelper.display({
            id: "actions",
            header: "Actions",
            classes: 'text_right',
            cell: props => <IncompleteTableActions row={props.row.original} />,
        }),
    ];

    const [params, setParams] = useState({
        per_page: 20,
        search: '',
        page:1
    })

  return (
      <Card title={"Incomplete Checkout"} >
          <Table queryKey={`incomplete-checkout`}
                 columns={columns}
                 queryParams={{...params}}
                 queryFn={getIncompleteCheckout} />
      </Card>
  );
}

export default IncompleteIndex